export const installPhoneConversionTracking = (): (() => void) => {
  const handlePhoneLinkClick = (event: MouseEvent) => {
    if (!(event.target instanceof Element)) return;

    const phoneLink = event.target.closest<HTMLAnchorElement>('a[href^="tel:"]');
    if (!phoneLink) return;

    event.preventDefault();

    let hasNavigated = false;
    let fallbackTimeout: number;
    const navigateToPhone = () => {
      if (hasNavigated) return;
      hasNavigated = true;
      window.clearTimeout(fallbackTimeout);
      window.location.href = phoneLink.href;
    };

    if (!window.gtag) {
      window.location.href = phoneLink.href;
      return;
    }

    fallbackTimeout = window.setTimeout(navigateToPhone, 1000);
    window.gtag("event", "conversion", {
      send_to: "AW-18332455597/oSapCIOn0pEdEK2lzKVE",
      value: 1.0,
      currency: "EUR",
      event_callback: navigateToPhone,
    });
  };

  document.addEventListener("click", handlePhoneLinkClick, true);
  return () => document.removeEventListener("click", handlePhoneLinkClick, true);
};